import { styled } from "@mui/material/styles"
import ArticleHeader from "Components/Article/ArticleHeader"
import Breadcrumbs from "Components/Breadcrumbs"
import Head from "Components/Head"
import Layout from "Components/Layout/Layout"
import Sections from "Components/Templates/Sections"
import { getFooter, getPage } from "data/contentData/api/content"
import { getMegamenu } from "data/contentData/api/megamenu"
import { IMegamenuCategory } from "data/contentData/interfaces/IMegamenuCategory"
import { IContainerCard } from "data/contentData/interfaces/mongodb/IContainerCard"
import { IPage } from "data/contentData/interfaces/mongodb/IPage"
import { IPublic } from "data/contentData/interfaces/mongodb/IPublic"
import useGtmCustomVariables from "lib/hooks/useGtmCustomVariables"
import { rewrites } from "lib/routes"
import { useEffect, useRef } from "react"

export default function CookieDeclaration({
  page,
  footer,
  megamenu,
}: {
  page: IPage
  footer: IContainerCard[]
  megamenu: IMegamenuCategory[]
}) {
  useGtmCustomVariables()
  const scriptRoot = useRef<HTMLDivElement>(null)
  const script = `<script id="CookieDeclaration" src="https://consent.cookiebot.com/${process.env.NEXT_PUBLIC_COOKIEBOT_ID}/cd.js" type="text/javascript" defer/>`

  useEffect(() => {
    const range = document.createRange()
    const documentFragment = range.createContextualFragment(script)
    scriptRoot.current?.append(documentFragment)
  }, [script])

  return (
    <Layout footer={footer} megamenu={megamenu}>
      <Breadcrumbs page={page} />
      <Head page={page} />
      <StyledWrapper>
        <ArticleHeader page={page as IPublic} />
        <div className="article">
          <Sections sections={page.sections} />
          <div ref={scriptRoot} />
        </div>
      </StyledWrapper>
    </Layout>
  )
}

const StyledWrapper = styled("main")(({ theme }) => ({
  padding: theme.spacing(2),
  margin: `${theme.spacing(2)} 0`,
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(4),
  },
}))

export async function getServerSideProps() {
  const page = await getPage(rewrites["/cookie-declaration"], false)
  const footer = await getFooter()
  const megamenu = await getMegamenu()

  return {
    props: {
      page,
      footer,
      megamenu,
    },
  }
}
